module.exports = __webpack_public_path__ + "img/sms.13ad893f.jpg";